(function () {

    angular
        .module('app')
        .service('languageModelService', languageModelService);

    languageModelService.$inject = [
        '$http',
        'qitanAiContractService'
    ];

    function languageModelService($http, qitanAiContractService) {

        function generateNgrams(userid, tenant, inputstrings) {
            var url = qitanAiContractService.getTrainingApiUrl('prepareNgrams', {
                classid : tenant,
                studentid : userid
            });
            return $http.post(url, { input : inputstrings })
                .then((resp) => {
                    return resp.data;
                });
        }


        return {
            generateNgrams
        };
    }
})();
